import { Clickable, Icon, Row, Text } from 'components';
import { useOutsideClick } from 'core';
import { theme } from 'lib';
import { useRef, useState } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
`;

const Container = styled.div`
  width: 240px;
  position: absolute;
  background-color: #fff;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.1);
  z-index: 3;
  top: 30px;
  right: 0;
`;

/*
  Settings dropdown with gear icon used with every entity
*/
const Settings = ({ user, options = [], ExtraComponent, col }) => {
  const [visible, setVisible] = useState(false),
    wrapperRef = useRef();

  useOutsideClick(wrapperRef, () => visible && handleVisible());

  function handleVisible() {
    setVisible(!visible);
  }

  function handleClick(item) {
    !item.dontCloseOnClick && handleVisible();

    item.onClick();
  }

  return (
    <Wrapper ref={wrapperRef}>
      <Clickable onClick={handleVisible}>
        <Icon type="settings" dimensions={18} col={col} />
      </Clickable>

      {visible && (
        <Container>
          {options.map((x, i) => {
            if (x.shouldHide) return null;

            return (
              <Clickable key={i} disabled={x.isDisabled} onClick={() => handleClick(x)}>
                <Row noFlex ht="48px" center>
                  <Icon
                    dimensions={x.iconDimensions || 18}
                    type={x.icon}
                    col={theme.GREY_60}
                    marg="0 0 0 16px"
                  />

                  <Text med b2 marg="0 0 0 8px">
                    {x.text}
                  </Text>
                </Row>
              </Clickable>
            );
          })}

          {ExtraComponent && <ExtraComponent />}
        </Container>
      )}
    </Wrapper>
  );
};

export default Settings;
